import { AirdropVault } from "@components/V2/Vault";
import PageLayout from "@components/PageLayout";
import { AirdropVaultProvider } from "@providers/AirdropVaultProvider";
import { fetchStrapiData } from "@services/strapi";
import {
  QueryClient,
  dehydrate,
  HydrationBoundary,
} from "@tanstack/react-query";
import { getVaultChartData } from "@services/index";

export const getStaticProps = async () => {
  const queryClient = new QueryClient();

  // Prefetch APR data for ageth
  await queryClient.prefetchQuery({
    queryKey: ["apr-data", "ageth"],
    queryFn: async () => {
      const r = await getVaultChartData("ageth");
      return r.data;
    },
    staleTime: 1 * 60 * 60 * 1000,
  });

  const res = await fetchStrapiData("strategy-allocations");

  return {
    props: {
      dehydratedState: dehydrate(queryClient),
      page: {
        data: {
          cmsAllocations: (() => {
            if (res?.data?.length > 0) {
              const vaultData = res.data.find(
                (data: any) => data?.attributes?.vault_name === "airdrop_vault"
              );

              return vaultData?.attributes || [];
            }
            return [];
          })(),
        },
      },
    },
  };
};

const ValutPage = (props: { page: any; dehydratedState: any }) => {
  return (
    <HydrationBoundary state={props.dehydratedState}>
      <PageLayout extraMarginTop={false}>
        <AirdropVaultProvider
          data={{ cmsAllocations: props.page.data.cmsAllocations }}
        >
          <AirdropVault />
        </AirdropVaultProvider>
      </PageLayout>
    </HydrationBoundary>
  );
};

export default ValutPage;
